import { useEffect, useState } from "react";
import { Plus, Trash2, Loader2, ShieldCheck, User } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AgentsAdmin() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "agent" });
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/admin/agents").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name || !form.email || !form.password) { toast.error("Tous les champs sont requis"); return; }
    setSaving(true);
    try {
      await api.post("/admin/agents", form);
      setForm({ name: "", email: "", password: "", role: "agent" });
      toast.success("Membre ajouté"); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setSaving(false); }
  };
  const remove = async (u) => { if (!window.confirm(`Supprimer ${u.name} ?`)) return; try { await api.delete(`/admin/agents/${u.id}`); toast.success("Supprimé"); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } };

  const field = "w-full rounded-lg border border-border px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary";

  return (
    <div>
      <h1 className="font-heading text-3xl font-black text-ink">Équipe</h1>
      <p className="text-ink/50 mt-1">Gérez les membres qui traitent les leads et les conversations en direct.</p>

      {user?.role === "admin" && (
        <div className="mt-6 bg-card border border-border rounded-xl p-4 grid grid-cols-1 sm:grid-cols-5 gap-3 items-end">
          <div><label className="text-xs font-semibold text-ink/60">Nom</label><input data-testid="agent-name" className={field} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></div>
          <div><label className="text-xs font-semibold text-ink/60">Email</label><input data-testid="agent-email" className={field} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
          <div><label className="text-xs font-semibold text-ink/60">Mot de passe</label><input data-testid="agent-password" type="password" className={field} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} /></div>
          <div><label className="text-xs font-semibold text-ink/60">Rôle</label><select className={field} value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}><option value="agent">Agent</option><option value="admin">Admin</option></select></div>
          <button onClick={add} disabled={saving} data-testid="agent-add" className="inline-flex items-center justify-center gap-2 bg-primary text-white font-bold py-2.5 rounded-lg disabled:opacity-60">{saving ? <Loader2 className="animate-spin" size={16} /> : <Plus size={16} />} Ajouter</button>
        </div>
      )}

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((u) => (
          <div key={u.id} className="bg-card border border-border rounded-xl p-5" data-testid={`agent-${u.id}`}>
            <div className="flex items-center justify-between">
              <div className="h-11 w-11 rounded-full bg-primary text-white flex items-center justify-center font-heading font-black">{u.name?.[0]}</div>
              <span className={`text-xs px-2 py-1 rounded-full inline-flex items-center gap-1 ${u.role === "admin" ? "bg-ink text-white" : "bg-accent text-ink/70"}`}>{u.role === "admin" ? <ShieldCheck size={12} /> : <User size={12} />} {u.role}</span>
            </div>
            <h3 className="mt-3 font-heading font-bold text-ink">{u.name}</h3>
            <p className="text-sm text-ink/50">{u.email}</p>
            <div className="mt-2 flex items-center gap-2 text-xs">
              <span className={`h-2 w-2 rounded-full ${u.is_available ? "bg-green-500" : "bg-ink/20"}`} />
              <span className="text-ink/50">{u.is_available ? "Disponible" : "Indisponible"}</span>
            </div>
            {user?.role === "admin" && u.role !== "admin" && (
              <button onClick={() => remove(u)} className="mt-3 inline-flex items-center gap-1 text-xs text-red-600 hover:underline"><Trash2 size={13} /> Supprimer</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
